import { ListItemInteractive } from './interactive'
import { ListItemTitle } from './title'
import { ListItemSeparator } from './separator'

const ListItem = {
	Interactive: ListItemInteractive,
	Title: ListItemTitle,
	Separator: ListItemSeparator,
}

export { ListItem }
